import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// 404 fallback rendered by NotFoundGate when the current pathname
// doesn't match any known route. Was D-03: hitting a bad URL landed
// on a blank white page because Navigation contained no catch-all.
const NotFoundScreen = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #fafbfc 0%, #f8fafc 100%)',
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Inter', sans-serif",
        zIndex: 9998,
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 480, padding: 32 }}>
        <div style={{ fontSize: 96, fontWeight: 900, color: '#800020', lineHeight: 1, marginBottom: 8 }}>404</div>
        <div style={{ fontSize: 22, fontWeight: 700, color: '#1e293b', marginBottom: 12 }}>
          {t('screens.notFound.title')}
        </div>
        <div style={{ fontSize: 14, color: '#64748b', marginBottom: 24 }}>
          {t('screens.notFound.subtitle')}
        </div>
        <div style={{ fontSize: 12, color: '#94a3b8', marginBottom: 32, fontFamily: 'monospace' }}>
          {location.pathname}
        </div>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
          <button
            type='button'
            onClick={() => history.push('/dashboard')}
            style={{
              background: '#800020',
              color: '#fff',
              border: 'none',
              padding: '12px 24px',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {t('screens.notFound.dashboard')}
          </button>
          <button
            type='button'
            onClick={() => history.goBack()}
            style={{
              background: '#fff',
              color: '#1e293b',
              border: '1px solid #e2e8f0',
              padding: '12px 24px',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {t('screens.notFound.back')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundScreen;
